import styled, { DefaultTheme, withTheme } from 'styled-components';
import React from 'react';
import { transparentize } from 'polished';
import {
    invoiceStatus,
    orderStatus,
    paylinkStatus,
    httpStatusGroup,
} from '../../../services/helpers/status';
import StatusTypes from '../../../types/StatusTypes';

type Props = {
    status?: string;
    background?: string;
    padding?: boolean;
    text?: string;
    type: StatusTypes;
    theme: DefaultTheme;
    height?: string;
};

type StatusDivProps = {
    color: string;
};

const Status: React.FC<Props> = ({
    status,
    background,
    padding,
    type,
    text,
    theme,
    height,
}: Props) => {
    const getCorrectStatus = () => {
        if (status && type === StatusTypes.Order) {
            return orderStatus(status, theme.colors.status);
        }
        if (status && type === StatusTypes.Invoice) {
            return invoiceStatus(status, theme.colors.status);
        }

        if (status && type === StatusTypes.Paylink) {
            return paylinkStatus(status, theme.colors.status);
        }

        if (status && type === StatusTypes.HTTP) {
            return httpStatusGroup(status, theme.colors.httpStatusGroup);
        }
        return { text: status, color: theme.colors.status.default };
    };

    const statusType = getCorrectStatus();

    return (
        <FlexContainer
            background={background}
            status={status}
            padding={padding}
            type={type}
            height={height}
        >
            <StatusContainerDiv>
                <StatusDiv color={statusType.color} />
            </StatusContainerDiv>
            <StatusText>{text ?? statusType.text}</StatusText>
        </FlexContainer>
    );
};

const FlexContainer = styled.div<Props>`
    display: inline-flex;
    flex-direction: row;
    background-color: ${props =>
        props.background
            ? props.background
            : props.type === StatusTypes.HTTP
            ? transparentize(
                  0.9,
                  httpStatusGroup(props.status || '', props.theme.colors.httpStatusGroup).color
              )
            : transparentize(
                  0.9,
                  orderStatus(props.status || '', props.theme.colors.status).color
              )};
    padding: ${props => (props.padding === false ? '0' : '0.5rem')};
    margin-right: 0.5rem;
    border-radius: 5rem;
    white-space: nowrap;
    height: ${props => props.height};
`;

const StatusContainerDiv = styled.div`
    padding-right: ${props => props.theme.layout.padding.small};
    align-self: center;
`;

const StatusDiv = styled.div<StatusDivProps>`
    width: 1rem;
    height: 1rem;
    border-radius: 5rem;
    align-self: center;
    background-color: ${props => props.color};
`;

const StatusText = styled.span`
    margin-right: ${props => props.theme.layout.padding.xsmall};
    align-self: center;
`;

export default withTheme(Status) as React.ComponentType<Omit<Props, 'theme'>>;
